import type { NavigationGuard } from 'vue-router';
import { useAuth0 } from '@auth0/auth0-vue';
import { watch } from 'vue';

/**
 * Navigation guard that redirects authenticated users to /wallets.
 * Use this for guest-only pages like home, login, and signup.
 */
export const guestGuard: NavigationGuard = async (to, from, next) => {
  const auth0 = useAuth0();

  // Wait for Auth0 to finish loading
  if (auth0.isLoading.value) {
    await new Promise<void>((resolve) => {
      // If already done loading, resolve immediately
      if (!auth0.isLoading.value) {
        resolve();
        return;
      }

      const unwatch = watch(
        () => auth0.isLoading.value,
        (isLoading) => {
          if (!isLoading) {
            unwatch();
            resolve();
          }
        },
        { immediate: true },
      );
    });
  }

  // If authenticated, redirect to wallets
  if (auth0.isAuthenticated.value) {
    next({ name: 'wallets' });
    return;
  }

  next();
};
